import { Card, Collapse, Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import DataTable from "components/DataTable";
import SinDatos from "components/Carteles/SinDatos";
import { memo, useContext, useMemo, useState } from "react";
import { getUproColor } from "utils/colors";
import { MenuContext } from "context/menuContext";
import listaDetalleData from "./data/listaDetalleData";
import { formatMoneyPunto } from "utils/formatters";

function EmpleadoDetalle({ empleado, setEmpleadoSelected, handleUpdateEstado = () => { } }) {
    const [expanded, setExpanded] = useState(false);
    const { columns, getRows } = listaDetalleData;
    const { menu } = useContext(MenuContext);

    const rows = useMemo(() => {
        const detalles = empleado.detalles.filter((prod) => prod.estado !== 'CANCELADO')
        return getRows(detalles, (event, item) => {
            menu({
                open: event.currentTarget,
                align: "right",
                options: [
                    {
                        name: "marcar el producto como entregado",
                        onClick: item?.estado !== 'PENDIENTE' ? () => { } : () => handleUpdateEstado(empleado.idEmpleado, item, "ENTREGADO"),
                        disabled: item?.estado !== 'PENDIENTE' ? true : false,
                        icon: { icon: "check", color: getUproColor("uproGreen") },
                    },
                    {
                        name: "quitar este producto de la lista",
                        onClick: item?.estado !== 'PENDIENTE' ? () => { } : () => handleUpdateEstado(empleado.idEmpleado, item, "CANCELADO", "Cancelado por usuario"),
                        disabled: item?.estado !== 'PENDIENTE' ? true : false,
                        icon: { icon: "remove", color: 'error' },
                    }
                ],
                handleClose: () => { },
            });
        });
    }, [empleado.detalles, getRows, handleUpdateEstado]);

    const total = useMemo(() => {
        let totalAcumulado = 0;
        (empleado?.detalles || []).forEach((detalle) => {
            if (detalle.estado !== "CANCELADO") {
                totalAcumulado += Number(detalle.precioEditado ?? detalle.precio) * detalle.cantidad;
            }
        });
        return totalAcumulado;
    }, [empleado.detalles]);

    return (
        <Card
            key={empleado.id}
            sx={{
                border: "1px solid rgba(0, 0, 0, 0.12)",
                mb: 2,
                display: { xs: "none", sm: "block" }
            }}
        >
            <SoftBox
                display="flex"
                justifyContent="space-between"
                px={2}
                py={1}
                sx={{
                    borderBottom: expanded
                        ? "1px solid rgba(0, 0, 0, 0.12)"
                        : "none",
                    cursor: "pointer",
                    "&:hover": {
                        backgroundColor: "rgba(0, 0, 0, 0.04)",
                    }
                }}
                onClick={(e) => { e.stopPropagation(); setEmpleadoSelected(empleado); setExpanded(!expanded); }}
            >
                <SoftBox display="flex" alignItems="center" gap={1}>
                    <SoftBox display="flex" alignItems="center" pb={1}>
                        <SoftBox mr={1}>
                            <Card>
                                <SoftBox
                                    bgColor={getUproColor("uproGreen")}
                                    sx={{ width: "30px", height: "30px" }}
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    <Icon fontSize="small" sx={{ color: "#fff" }}>
                                        person
                                    </Icon>
                                </SoftBox>
                            </Card>
                        </SoftBox>
                        <SoftTypography variant="h6" fontWeight="bold">
                            {`${empleado.nombre} ${empleado.apellido}`}
                        </SoftTypography>
                    </SoftBox>
                </SoftBox>
                <SoftBox display="flex" alignItems="center" gap={1}>
                    {rows?.length === 0 ?
                        (<>
                            {/* <Tooltip title={'Quitar empleado'} placement="top">
                                <SoftButton
                                    color="secondary"
                                    circular
                                    iconOnly
                                    onClick={(e) => { e.stopPropagation(); handleUpdateEstado(empleado.idEmpleado, null, null, "", { removeEmpleado: true }) }}
                                >
                                    <Icon>
                                        remove
                                    </Icon>
                                </SoftButton>
                            </Tooltip> */}
                            <SoftTypography variant='body2' fontWeight="bold">
                                Sin productos para mostrar
                            </SoftTypography>
                        </>) :
                        (
                            <>
                                {/* {!(empleado.detalles || []).some((detalle) => detalle.estado === 'ENTREGADO') && (<Tooltip title={'Quitar empleado'} placement="top">
                                    <SoftButton
                                        color="secondary"
                                        circular
                                        iconOnly
                                        onClick={(e) => { e.stopPropagation(); handleUpdateEstado(empleado.idEmpleado, null, null, "", { removeEmpleado: true }) }}
                                    >
                                        <Icon
                                        // onClick={(e) => {e.stopPropagation(); handleUpdateEstado(empleado.idEmpleado, null, null, "", { removeEmpleado: true })}}
                                        >
                                            remove
                                        </Icon>
                                    </SoftButton>
                                </Tooltip>)} */}
                                <Tooltip title={expanded ? "Ocultar" : "Mostrar"} placement="top">
                                    <SoftButton
                                        color="primary"
                                        circular
                                        iconOnly
                                        onClick={() => setExpanded(!expanded)}
                                    >
                                        <Icon
                                            onClick={() => setExpanded(!expanded)}
                                            sx={{
                                                rotate: expanded ? "180deg" : "0deg",
                                                transition: "all 0.5s",
                                            }}
                                        >
                                            expand_more
                                        </Icon>
                                    </SoftButton>
                                </Tooltip>
                            </>
                        )
                    }
                </SoftBox>
            </SoftBox>
            <Collapse in={expanded} mountOnEnter unmountOnExit>
                <SoftBox py={2} px={2}>
                    {rows?.length > 0 ? (
                        <DataTable
                            columns={columns}
                            rows={rows}
                        />
                    ) : (
                        <SinDatos mensaje="No hay productos asociados a este empleado." />
                    )}
                </SoftBox>
                <Collapse in={rows?.length > 0}>
                    <Card
                        sx={{
                            borderTopLeftRadius: 0,
                            borderTopRightRadius: 0,
                            position: "sticky",
                            marginTop: -2,
                            zIndex: 1,
                        }}
                    >
                        <SoftBox bgColor={getUproColor('terraPrimary')}>
                            <SoftBox
                                display="flex"
                                justifyContent="center"
                                p={2}
                            >
                                <SoftTypography
                                    variant="h6"
                                    fontWeight="bold"
                                    color="white"
                                >
                                    Total: $ {formatMoneyPunto(total)}
                                </SoftTypography>
                            </SoftBox>
                        </SoftBox>
                    </Card>
                </Collapse>
            </Collapse>
        </Card>
    );
}

export default memo(EmpleadoDetalle);